import styled from '@emotion/styled';
import {fonts, colors} from 'ui/config';
import {Img as ImgUI, ButtonLink} from 'ui';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  padding: 20,
  paddingBottom: 10,
  backgroundColor: '#fff',
  width: 280,
  height: 380,
  marginLeft: 8,
  marginRight: 8,
});

export const Img = styled(ImgUI)({
  height: 148,
  width: 200,
  '& img': {
    height: 148,
    width: 200,
    objectFit: 'contain',
  },
});

export const Points = styled('div')({
  fontFamily: fonts.title,
  color: colors.caramel,
  fontSize: 26,
  fontWeight: 'bold',
  marginTop: 10,
  marginBottom: 5,
  '& span': {
    position: 'relative',
    top: -6,
    left: -3,
    fontSize: 16,
  },
});

export const GiftName = styled('div')({
  fontFamily: fonts.title,
  color: colors.black,
  fontSize: 16,
  fontWeight: 'bold',
  marginTop: 7,
  marginBottom: 7,
});

export const GiftValue = styled('div')({
  color: colors.black,
  fontSize: 14,
  marginBottom: 19,
});

export const Button = styled(ButtonLink)({
  border: `1px solid ${colors.caramel}`,
  maxWidth: '100%',
  marginTop: 'auto',
  '& span': {
    padding: '12px 20px',
    fontSize: 16,
    border: 'none',
  },
});
